import React, { useEffect, useState } from 'react'
import ContainerLayout from '../../../../components/container-layout/ContainerLayout'
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom'
// import { RoutePath } from '../../../routes/Routes'
import { UploadImagePreview } from '../../../../components/upload-image-preview/UploadImagePreview'
import StateComponents from '../../../../components/state-component/StateComponents'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import ContainerButton from '../../../../components/button/ContainerButton'
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice'
import { formStateFooter, WebsiteStructureApi } from '../../../../api/website-structure/WebsiteStructure.api'
import { alertError, alertSuccess } from '../../../../components/alert/swal'
import { checkPermission, getBaseApi } from '../../../../utils/app.utils'
import ModalMedia from '../../media/modal-media/ModalMedia'
import CheckBoxCustom from '../../../../components/checkbox/CheckBoxCustom'
import { SocialMediaApi } from '../../../../api/social-media/social_media.api'
import { MenuApi } from '../../../../api/menu/menu.api'
import { flattenMenu } from '../menu/util'
import { ContactApi } from '../../../../api/contact/contact.api'
import { RootState } from '../../../../store/store'
import { routeName } from '../../../../routes/routeName'

type Props = {}



const FooterStructure: React.FC<Props> = ({ }: Props) => {
    const base_api_image = getBaseApi();

    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();


    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_FOOTER', permission);

    const [showModal, setShowModal] = useState<string>("")
    const [id_footer, set_id_footer] = useState<number | null>(null);
    const [file_api_url, set_file_api_url] = useState<string>("");
    const [file, setFile] = useState<any[]>([]);
    const [id_media_file, set_id_media_file] = useState<number | null>(null);

    const [social_media_data, set_social_media_data] = useState<any[]>([]);
    const [menu_data, set_menu_data] = useState<any[]>([]);
    const [checked, setChecked] = useState<number[]>([]);
    const [select_social_media_data, set_select_social_media_data] = useState<number[]>([]);

    const [formState, setFormState] = useState<formStateFooter>({
        footer_contact_suggestions: "",
        footer_copyright: "",
        footer_desc: "",
        footer_desc_color: "",
        footer_sub_text: "",
        footer_sub_text_color: "",
        footer_menu: [],
        footer_name: "",
        footer_name_color: "",
        footer_social_media: [],
        footer_tel: "",
        footer_website: "",
        id_media_file: null
    })
    const handleChangeFormState = (field: keyof formStateFooter, value: string) => {
        setFormState((prev) => ({ ...prev, [field]: value }))
    }
    const handleCloseModal = () => {
        setShowModal("");
    }

    const handleChangeSocialMediaData = (id_social_media: number) => {
        if (select_social_media_data?.some((x) => x === id_social_media)) {
            set_select_social_media_data((prev) => prev?.filter((x) => x !== id_social_media))
        } else {
            set_select_social_media_data((prev) => ([...prev, id_social_media]))
        }
    }

    const generateForm = (id_media_file: number | null | undefined): formStateFooter => {
        return {
            ...formState,
            footer_menu: menu_data?.filter((x) => checked.includes(x?.id_menu)).map((list) => {
                return {
                    id_footer_menu: list?.id_footer_menu || null,
                    id_menu: list?.id_menu,
                }
            }),
            footer_social_media: social_media_data?.filter((x) => select_social_media_data.includes(x?.id_social_media)).map((list) => {
                return {
                    id_footer_social_media: list?.id_footer_social_media,
                    id_social_media: list?.id_social_media
                }
            }),
            ...(id_media_file && {
                id_media_file: id_media_file
            })
        }
    }
    const handleSubmit = async (id_media_file?: number) => {
        dispatch(setLoading());
        const body = generateForm(id_media_file);
        if (id_footer) {
            await WebsiteStructureApi.updatedFooter(id_footer, body).then((res) => {
                if (res.status < 300) {
                    handleGetDataFooter();
                    alertSuccess("อัพเดตข้อมูล", "อัพเดตข้อมูลจัดการ Footer เรียบร้อย");
                }
            }).catch((err) => {
                console.log(err);
                alertError("Footer updated failed!")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await WebsiteStructureApi.createdFooter(body).then((res) => {
                if (res.status < 300) {
                    handleGetDataFooter();
                    alertSuccess("อัพเดตข้อมูล", "อัพเดตข้อมูลจัดการ Footer เรียบร้อย");
                }
            }).catch((err) => {
                console.log(err);
                alertError("Footer created failed!")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    const handleGetContactData = async () => {
        dispatch(setLoading());
        await ContactApi.findOne().then((res) => {
            if (res.status < 300) {
                const contact_data = res.data?.data?.contact;
                setFormState((prev) => ({
                    ...prev,
                    footer_tel: contact_data?.contact_tel || prev?.footer_tel,
                    footer_contact_suggestions: contact_data?.contact_suggestions || prev?.footer_contact_suggestions,
                    footer_desc: contact_data?.contact_address || prev?.footer_desc
                }))
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleGetDataFooter = async () => {
        dispatch(setLoading());
        await WebsiteStructureApi.getFooter().then((res) => {
            if (res.status < 300) {
                const data = res.data?.data;
                const url_image: string = `${base_api_image}/${data.footer_file?.media_file_path}${data.footer_file?.media_file_name}`;
                set_file_api_url(url_image)
                set_id_footer(data?.id_footer);
                const footer_menu_data = data?.footer_menu?.map((list: any) => list?.id_menu) || [];
                const social_media_data_id = data?.footer_social_media?.map((list: any) => list?.id_social_media) || [];
                set_select_social_media_data(social_media_data_id)
                setChecked(footer_menu_data)
                setFormState((prev) => ({
                    ...prev,
                    footer_name: data?.footer_name,
                    footer_name_color: data?.footer_name_color,
                    footer_desc: data?.footer_desc,
                    footer_desc_color: data?.footer_desc_color,
                    footer_sub_text: data?.footer_sub_text,
                    footer_sub_text_color: data?.footer_sub_text_color,
                    footer_tel: data?.footer_tel,
                    footer_contact_suggestions: data?.footer_contact_suggestions,
                    footer_copyright: data?.footer_copyright,
                    footer_website: data?.footer_website,
                    footer_menu: data?.footer_menu,
                    id_media_file: data?.id_media_file
                }))
            }
        }).catch((err) => console.log(err)).finally(() => {
            dispatch(unsetLoading());
        })
    }

    const handleGetSocialMedia = async () => {
        await SocialMediaApi.getList({ page: 1, limit: 1000 }).then((res) => {
            if (res.status < 300) {
                const list_data: any[] = res.data?.data?.data?.items || [];
                set_social_media_data(list_data);
            }
        }).catch((err) => console.log(err))
    }


    const handleGetMenuTree = async () => {
        await MenuApi.getMenuTree({}).then((res) => {
            if (res.status < 300) {
                const all_menu_list: any[] = res.data?.data || [];
                const menu_list = flattenMenu(all_menu_list);
                set_menu_data(menu_list);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        handleGetMenuTree();
        handleGetDataFooter();
        handleGetSocialMedia();
    }, [])

    return (
        <ContainerLayout
            title=''
            titleName='Footer'
            buttonContent={
                <ContainerButton
                    justifyContent='flex-end'
                    buttonData={[
                        {
                            seq: 1,
                            buttonProps: {
                                onClick: () => navigate(-1)
                            },
                            key: "BACK",
                            label: "ย้อนกลับ",
                            type: "BACK"
                        },
                        {
                            seq: 2,
                            hidden: !checkPermit.isUpdate,
                            buttonProps: {
                                onClick: () => handleSubmit()
                            },
                            key: "SAVE",
                            label: "บันทึก",
                            type: "SAVE"
                        },
                    ]}
                />
            }
            navigateContent={
                <NavigateListCustom
                    navigateData={
                        [
                            {
                                key: "โครงสร้างเว็บไซต์",
                                name: "โครงสร้างเว็บไซต์",
                                pathName: "",
                                disabled_match: true
                            },
                            {
                                key: "Footer",
                                name: "Footer",
                                pathName: routeName.cms_website.website_structure_footer,
                            },
                        ]}
                />
            }
            enablePadding
            content={
                <div className='w-full' >
                    <UploadImagePreview
                        heading='ปรับแต่ง Logo'
                        sub_heading='ขนาดภาพที่แนะนำ 142x142px สกุลไฟล์ .png'
                        image_file_blob={file[0]}
                        onChange={(f) => {
                            setFile(f);
                        }}
                        disabled={true}
                        image_file_url={file_api_url}
                        multiple={false}
                        onClick={() => setShowModal("ADD")}
                        onClear={() => {
                            set_file_api_url("");
                            setFile([]);
                        }}
                    />

                    <StateComponents
                        sxContainer={{ mt: 4 }}
                        otherProps={{ spacing: 2 }}
                        typeProps={[
                            {
                                seq: 1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 10
                                },
                                fieldProps: {
                                    heading: "ข้อความใหญ่",
                                    placeholder: "ระบุ",
                                    value: formState.footer_name,
                                    onChange: (e) => handleChangeFormState("footer_name", e.target.value)
                                }
                            },
                            {
                                seq: 2,
                                type: "COLOR_PICKER",
                                gridProps: {
                                    xs: 12,
                                    md: 2
                                },
                                fieldProps: {
                                    heading: "สี",
                                    placeholder: "ระบุ",
                                    value: formState.footer_name_color,
                                    onChange: (e) => handleChangeFormState("footer_name_color", e.target.value)
                                }
                            },
                            {
                                seq: 2.1,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                    md: 10
                                },
                                fieldProps: {
                                    heading: "ข้อความย่อย",
                                    placeholder: "ระบุ",
                                    value: formState.footer_sub_text,
                                    onChange: (e) => handleChangeFormState("footer_sub_text", e.target.value)
                                }
                            },
                            {
                                seq: 2.2,
                                type: "COLOR_PICKER",
                                gridProps: {
                                    xs: 12,
                                    md: 2
                                },
                                fieldProps: {
                                    heading: "สี",
                                    placeholder: "ระบุ",
                                    value: formState.footer_sub_text_color,
                                    onChange: (e) => handleChangeFormState("footer_sub_text_color", e.target.value)
                                }
                            },
                            {
                                seq: 3,
                                type: "COMPONENT",
                                gridProps: {
                                    xs: 12
                                },
                                fieldProps: {
                                    element: (
                                        <div className='w-full '>
                                            <CheckBoxCustom setChecked={(st) => {
                                                if (st) {
                                                    handleGetContactData();
                                                }
                                            }} label='ใช้ข้อมูลจากการตั้งค่าช่องทางติดต่อ' />
                                        </div>
                                    )
                                }
                            },
                            {
                                seq: 4,
                                type: "COLOR_PICKER",
                                gridProps: {
                                    md: 2
                                },
                                fieldProps: {
                                    heading: "สี",
                                    placeholder: "ระบุ",
                                    value: formState.footer_desc_color,
                                    onChange: (e) => handleChangeFormState("footer_desc_color", e.target.value)
                                }
                            },
                            {
                                seq: 5,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    heading: "ข้อความย่อยหรือข้อมูลที่ตั้ง (ภาษาไทย)",
                                    placeholder: "ระบุ",
                                    value: formState.footer_desc,
                                    multiline: true,
                                    row: 6,
                                    maxRows: 6,
                                    inputHeight: 'auto',
                                    disablePaddingMultiline: true,
                                    onChange: (e) => handleChangeFormState("footer_desc", e.target.value)
                                }
                            },
                            {
                                seq: 6,
                                type: "TEXT-MASK",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    mode: "phone",
                                    heading: "โทรศัพท์",
                                    placeholder: "ระบุ",
                                    value: `${formState.footer_tel || ""}`,
                                    onChange: (e) => handleChangeFormState("footer_tel", e.target.value),
                                }
                            },
                            {
                                seq: 7,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    heading: "ข้อเสนอแนะติดต่อ",
                                    placeholder: "ระบุ",
                                    value: formState.footer_contact_suggestions,
                                    onChange: (e) => handleChangeFormState("footer_contact_suggestions", e.target.value)
                                }
                            },
                            {
                                seq: 8,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    heading: "ลิขสิทธิ์ (Copyright)",
                                    placeholder: "ระบุ",
                                    value: formState.footer_copyright,
                                    onChange: (e) => handleChangeFormState("footer_copyright", e.target.value)
                                }
                            },
                            {
                                seq: 9,
                                type: "TEXT_FIELD",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    heading: "เว็บไซต์หลัก",
                                    placeholder: "ระบุ",
                                    value: formState.footer_website,
                                    onChange: (e) => handleChangeFormState("footer_website", e.target.value)
                                }
                            },
                            {
                                seq: 10,
                                type: "SELECT",
                                gridProps: {
                                    xs: 12,
                                },
                                fieldProps: {
                                    labelId: "label-select-id",
                                    options: menu_data?.map((list: any) => ({
                                        label: checked.includes(list?.id_menu) ? "✓" + " " + list?.menu_name : list?.menu_name || "",
                                        value: list?.id_menu,
                                    })) || [],
                                    selectId: "select-id",
                                    multiple: true,
                                    onCheckBox: (event: any) => {
                                        const {
                                            target: { value },
                                        } = event;
                                        setChecked(typeof value === 'string' ? value.split(',') : value)
                                    },
                                    renderValue: (selected: any[]) => {
                                        const selectedLabels = menu_data
                                            .filter(opt => selected.includes(opt?.id_menu))
                                            .map(opt => `${opt?.menu_name}`)
                                        return selectedLabels.join(", ")
                                    },
                                    value: checked,
                                    heading: "เมนู Footer",
                                    onChange: () => { },
                                }
                            },
                        ]}
                    />

                    <StateComponents
                        sxContainer={{ mt: 4 }}
                        heading={String("social media").toUpperCase()}
                        typeProps={[
                            {
                                seq: 1,
                                type: "COMPONENT",
                                gridProps: {
                                    xs: 12
                                },
                                fieldProps: {
                                    element: (
                                        <div className='w-full flex flex-col gap-2'>
                                            {social_media_data?.map((list) => {
                                                return (
                                                    <span className='w-full'>
                                                        <CheckBoxCustom
                                                            checked={list?.id_social_media === select_social_media_data?.find((x) => x === list?.id_social_media)}
                                                            setChecked={() => handleChangeSocialMediaData(list?.id_social_media)}
                                                            label={list?.social_media_name}
                                                        />
                                                    </span>
                                                )
                                            })}
                                        </div>
                                    )
                                }
                            }
                        ]}
                    />

                    {showModal !== "" && (
                        <ModalMedia
                            open
                            handleClose={handleCloseModal}
                            title='เพิ่มไฟล์'
                            id_media_file={id_media_file}
                            onSelectMediaFile={(_, id) => set_id_media_file(id)}
                            onSubmitMediaFile={(_, id_media_file) => {
                                handleCloseModal();
                                handleSubmit(id_media_file);
                            }}
                            onSubmitLocalFile={(id_media_file) => {
                                handleCloseModal();
                                handleSubmit(id_media_file);
                            }}
                        />
                    )}
                </div>
            }
        />
    )
}

export default FooterStructure